function AdminHomePage(props) {
  return <div className="admin_container"></div>;
}
export default AdminHomePage;
